import { ca } from '@cian/analytics';

interface ITrackAddNewbuildingFavorite {
  label: string;
  newbuildingId: number;
}

export function trackAddNewbuildingFavorite({ label, newbuildingId }: ITrackAddNewbuildingFavorite) {
  return ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: 'add_from_compare',
    label,
    products: [{ id: newbuildingId, offerType: 'JK' }],
  });
}
